import { useQueryStateContext } from '../../../../contexts';
import { useVisualComponentsContext } from '../../../../contexts/visualComponents';
import { useTranslation } from '../../../../hooks/useTranslation';
import { ValidatedMultiGeoLocationValueInputProps } from '../types';

export const MultiGeoLocationInput = ({
  comparator,
  dataType,
  field,
  fieldType,
  isInvalid,
  hasWarning,
  onChange,
  value,
}: ValidatedMultiGeoLocationValueInputProps) => {
  const { t } = useTranslation();
  const { isReadOnly } = useQueryStateContext();
  const { ConditionValueMultiGeoLocationValue: VisualComponent } = useVisualComponentsContext();

  const isDisabled = !!isReadOnly;
  const hasError = !!isInvalid;

  return (
    <VisualComponent
      comparator={comparator}
      dataType={dataType}
      field={field}
      fieldType={fieldType}
      hasError={hasError}
      hasWarning={hasWarning}
      isDisabled={isDisabled}
      onChange={onChange}
      placeholder={t('v2.conditionBuilder.multiGeoLocationPlaceholder')}
      value={value}
    />
  );
};
